export const advertisements = [
    {
      id: "ad-1",
      title: "Halo Studio",
      image: "/assets/Advertisement/advt-1.png",
      description:
        "Generative editing built for creators. Turn a rough cut into a release in minutes.",
      cta: "Learn More",
      sponsored: true,
    },
    {
      id: "ad-2",
      title: "Orbit Fund",
      image: "/assets/Advertisement/advt-2.png",
      description:
        "Grants for independent creators shipping community-first products.",
      cta: "Explore",
      sponsored: true,
    },
  ];
  
  export default advertisements;